import { FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";

function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-bg-overlay"></div>
      <motion.div 
        className="hero-content"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Elevate Your Business with <br/>
          <span className="hero-accent">Salesforce Excellence</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          We are specialized Salesforce consultants building high-impact clouds, intelligent integrations, and scalable CRM architectures that accelerate enterprise growth.
        </motion.p>

        <RouterLink to="/portfolio" className="hero-btn-link">
          <motion.button 
            className="hero-btn"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
          >
            Discover More <FaArrowRight style={{ marginLeft: "8px" }} />
          </motion.button>
        </RouterLink>
      </motion.div>
    </section>
  );
}

export default Hero;